(function ($) {
  $(document).on( 'ready', function(){
    $('.ns-sidebar-container').each(function () {
      var container = $(this);
      var countImgEditorial = $(this).find('.ns-img-editorial').length;
      var countHighchartsGraphics = $(this).find('.ns-highchart-graphic').length;
      var countImagePlaceholders = $(this).find('.ns-img-anchor').length;
      var graphicsTotal = countImgEditorial + countHighchartsGraphics;

      if (countImagePlaceholders <= graphicsTotal) {
        container.find('.ns-sidebar-container__sidebar > div').each(function (i) {
          container.find('.ns-img-anchor').eq(i).after('<div class="js-graphic-wrapper graphic-index-' + i + '"></div>');
        });
        $(this).attr('data-do-replace', 'true');
      } else {
        $(this).attr('data-do-replace', 'false');
        // console.log('more placeholders than graphics, not doing the image replacements');
      }
    });

    var sidebarBreakpoint = 768;
    var oldWidth = $(window).width();
    var currentlyVisible;

    if ($(window).width() < sidebarBreakpoint) {
      currentlyVisible = 'mobile';
      moveToContent();
    } else {
      currentlyVisible = 'desktop';
    }

    function moveToSidebar() {
      // console.log('move to sidebar');
      $('.ns-sidebar-container[data-do-replace="true"]').each(function () {
        var container = $(this);
        // console.log(container);
        container.find('.js-graphic-wrapper > div').each(function (i) {
          // console.log($(this));
          $(this).appendTo(container.find('.ns-sidebar-container__sidebar'));
        });
      });
      $(document).trigger('movedGraphicsToSidebar');
    }

    function moveToContent() {
      $('.ns-sidebar-container[data-do-replace="true"]').each(function () {
        var container = $(this);
        container.find('.ns-sidebar-container__sidebar > div').each(function (i) {
          $(this).appendTo(container.find('.ns-img-anchor').eq(i).next('.js-graphic-wrapper'));
        });
      });
      $(document).trigger('movedGraphicsToContent');
    }

    // console.log(currentlyVisible);

    var resizeTimer;
    $(window).on('resize', function (e) {

      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {

        currentWidth = $(window).width();
        if ((oldWidth < sidebarBreakpoint) && (currentWidth > sidebarBreakpoint)) {
          currentlyVisible = 'desktop';
          // console.log('switch to desktop');
          moveToSidebar();
        }

        if ((oldWidth > sidebarBreakpoint) && (currentWidth < sidebarBreakpoint)) {
          currentlyVisible = 'mobile';
          // console.log('switch to mobile');
          moveToContent();
        }

        oldWidth = currentWidth;
      }, 250);

    });

  });


})(jQuery);
